import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ChapterMemberListLayer from "../components/ChapterMemberListLayer";

const ChapterMemberListPage = () => {
    return (
        <MasterLayout>
            <ChapterMemberListLayer />
        </MasterLayout>
    );
};

export default ChapterMemberListPage;
